import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import PrivateRoute from "./helpers/PrivateRoute";

import LockScreen from './pages/LockScreen'
import ProgramPage from './pages/ProgramPage'
import RepertoirePage from './pages/RepertoirePage';
import ReportPage from './pages/ReportPage';

function Routing() {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route exact path="/" element={<LockScreen />} />
                <Route exact path="/repertoire" element={
                    <PrivateRoute>
                        <RepertoirePage />
                        {/* <MyPage/> */}
                    </PrivateRoute>
                } />
                <Route exact path="/program" element={
                    <PrivateRoute>
                        <ProgramPage />
                    </PrivateRoute>
                } />
                <Route exact path="/report" element={
                    <PrivateRoute>
                        <ReportPage />
                    </PrivateRoute>
                } />
            </Routes>
        </Router>
    )
}

export default Routing